import { Button } from "antd";
import styled from "styled-components";

type MenuButtonProps = {
  children: React.ReactNode;
  onClick?: React.MouseEventHandler<HTMLElement>;
  disabled?: boolean;
};

const StyledMenuButton = styled(Button)`
  border: 0;
  border-radius: 16px;
  box-shadow: none;
  color: #111111;
  font-family: "Diazo Ex Cond Bold";
  font-size: 18px;
  font-weight: 900;
  max-height: 40px;
  text-align: center;
  white-space: normal;
  padding: 16px 16px;

  &:hover, &:focus {
    box-shadow: 0 0 0 2px rgba(0, 9, 33, 0.74);
    color: #111111;
  }
`;

export default function MenuButton(props: MenuButtonProps) {
  return (
    <StyledMenuButton
      block
      disabled={props.disabled}
      onClick={props.disabled ? undefined : props.onClick}
      size="large"
    >
      {props.children}
    </StyledMenuButton>
  );
}
